import Tooltip from 'rc-tooltip';
import { PropsWithChildren, ReactNode } from 'react';

import './tabel-tip.scss';

interface TabelTipProps {
	message?: string | null;
	type?: 'error' | 'warning' | 'info' | 'posted' | string | null;
}

function TabelTip({ children, message, type }: PropsWithChildren<TabelTipProps>): ReactNode {
	if (!message) return children;

	const overlayClassName = ['custom-tooltip', `custom-tooltip--${type ?? 'info'}`];

	return (
		<Tooltip
			placement="bottomLeft"
			trigger={['hover', 'focus']}
			classNames={{ root: overlayClassName.join(' '), body: overlayClassName.join(' ') }}
			align={{
				autoArrow: true,
				targetOffset: [0, 10],
				offset: [0, 15],
			}}
			overlay={<div style={{ width: '200px', fontSize: '13px' }}>{message}</div>}
			styles={{
				root: {
					borderRadius: '10px',
					opacity: 1,
				},
			}}
		>
			<div>{children}</div>
		</Tooltip>
	);
}

export default TabelTip;
